import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CorteVentaEdit } from "./modalagregar";
import { GenerarReporteEdit } from "./modalGenerarReporte";


type Entity = models.CorteVentaDTO;
import { columnas } from "./columns";
const resource = resources.CorteVenta;
export class CorteVentaList extends React.PureComponent {
    modalManager = kea.createModalManager();

    onConsultarComisiones = async (x: Entity) => {
        const result = await this.modalManager.showModal(GenerarReporteEdit, undefined, undefined);
        if (result.result) {

            const func =
                 result.result == "resumen" ? resource.GenerarReporteComisiones :
                 result.result == "detalle" ? resource.GenerarReporteComisionDetalle :
                 assertUnreachable(result.result);

            var reporte = await func(x.IdRegistro, result.value || null);
            kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Comisiones de los vendedores.xls");
        }
    }



    items = observeResource(resource.query);

    onAgregar = async () => {
        const result = await this.modalManager.showModal(CorteVentaEdit, undefined, {
            FechaCorte: new Date()
        } as models.CorteVenta);
        if (result.result) {
            const idRegistro = await resource.add(result.value);
        }
    }

    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Calculo de comisiones" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"CorteVentaListCookieKey"} items={this.items} />
                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteventas/list/list.tsx